
// ShineCare - Cart quantity button repair
(() => {
  if (window.shinecareQuantityFixLoaded) return;
  window.shinecareQuantityFixLoaded = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest(
      'cart-items quantity-input button[name="plus"], ' +
      'cart-items quantity-input button[name="minus"]'
    );

    if (!button || button.disabled) return;

    const container = button.closest('quantity-input');
    const input = container?.querySelector('input.quantity__input');

    if (!input || input.disabled) return;

    // Let the theme handle clicks if it already works.
    // This repair is for the broken quantity handler.
    event.preventDefault();
    event.stopImmediatePropagation();

    const current = Number(input.value) || 1;
    const step = Number(input.step) || 1;
    const min = Number(input.min) || 1;
    const max = input.max ? Number(input.max) : Infinity;

    let next = button.name === 'plus'
      ? current + step
      : current - step;

    next = Math.max(min, Math.min(max, next));

    if (next === current) return;

    input.value = String(next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);
})();
